module.exports = __webpack_public_path__ + "img/franks_bride.471ec8a4.jpg";